import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appDropdownToggle]'
})
export class DropdownToggleDirective {

  private dropdownContainer: HTMLElement | null = null;
  private dropdownMenu: HTMLElement | null = null;
  private isOpen = false;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit() {
    this.dropdownContainer = this.el.nativeElement.closest('.dropdown');
    this.dropdownMenu = this.dropdownContainer?.querySelector('.dropdown-menu') ?? null;

  }

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    event.stopPropagation();
    this.isOpen ? this.close() : this.open();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (this.dropdownContainer && this.dropdownContainer.contains(event.target as Node)) {
      return;
    }
    this.close();
  }

  private open() {
    if (this.dropdownMenu && this.dropdownContainer) {
      this.renderer.addClass(this.dropdownContainer, 'show');
      this.renderer.addClass(this.dropdownMenu, 'show');
      this.isOpen = true;
    }
  }

  private close() {
    if (this.dropdownMenu && this.dropdownContainer) {
      this.renderer.removeClass(this.dropdownContainer, 'show');
      this.renderer.removeClass(this.dropdownMenu, 'show');
      this.isOpen = false;
    }
  }
}
